import { SelectOptionTP } from 'main/common/components/form-fields/select/inner/types/SelectOptionTP'
import { SelectCP } from 'main/common/components/form-fields/select/SelectCP'
import { PaymentMethodEnum } from 'submodules/neritclin-sdk/services/sale/paymentconfig/enums/PaymentMethodEnum'
import React from 'react'
import styled from 'styled-components'
import { IFormItemCommonProps } from 'main/common/components/form-fields/inner/interfaces/IFormItemCommonProps'
import { FormModel } from 'main/common/form-state-manager/FormModel'
import {
    FinancialTransactionGroupTypeEnum,
    FinancialTransactionGroupTypeLabelEnum
} from 'main/modules/financial/services/financial-transactions/enums/FinancialTransactionGroupTypeEnum'

interface ISelectRecurrenceTypeCPProps<FModelTP extends FormModel = any> extends IFormItemCommonProps<FModelTP, PaymentMethodEnum> {
    allowClear?: boolean
}

/**
 * Componente para select de formas tipos de recorrencia.
 */
export function SelectRecurrenceTypeCP(props: ISelectRecurrenceTypeCPProps): JSX.Element {

    const OPTIONS: SelectOptionTP[] = Object.values(FinancialTransactionGroupTypeEnum).map((item, i) => ({
        key: `key-item-${i}`,
        label: FinancialTransactionGroupTypeLabelEnum[item],
        value: item
    }))

    return (
        <SelectWrapperSCP>
            <SelectCP
                placeholder={props.placeholder}
                label={props.label}
                value={props.value}
                disabled={props.disabled}
                required={props.required}
                formStateManager={props.formStateManager}
                selectedOptions={props.value ? [props.value] : undefined}
                fieldName={props.fieldName}
                fontSize={props.fontSize}
                isMultiple={false}
                allowClear={props.allowClear}
                options={OPTIONS}
                defaultOpen={false}
                onChange={props.onChange}
                width={props.width}
            />
        </SelectWrapperSCP>
    )
}

const SelectWrapperSCP = styled.div`
    width:100%;
`
